import moment from "moment";

export const today = moment();
export const lastDayInYear = moment([moment().year(), 11, 31]);
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

/**
 * Stripe recurring prices are selected by `lookup_key`, never by their position
 * in the list the API returns and never by a hardcoded price id or amount.
 *
 * `prices.list()` returns newest first, so "the first BRL price" silently
 * became a R$ 100/year price the moment it was created on the dashboard, and
 * PT users were offered it labelled "/month" (ABR-283).
 *
 * These lookup keys must exist on Stripe before this code ships.
 */
export const RECURRING_PRICE_LOOKUP_KEY = {
  brl: "bbj_month_brl",
  usd: "bbj_month_usd",
};
